import { useTranslation } from "react-i18next";

const AboutCompanySection = () => {
  const { t } = useTranslation();
  return (
    <section
      id="o-kompanii"
      className="w-full min-h-[806px] md:min-h-[810px] relative bg-stone-300 overflow-hidden"
    >
      {/* Фон суреті */}
      <div className="absolute inset-0 z-0">
        <div className="w-full h-full bg-[url('/4-min%201.png')] lg:bg-auto bg-start bg-no-repeat md:translate-x-0" />
        {/* Градиент overlay */}
        <div className="hidden md:block absolute inset-0 bg-gradient-to-l from-neutral-100 via-neutral-50 to-neutral-50/0 md:bg-gradient-to-l md:from-neutral-100 md:via-neutral-50 md:to-neutral-50/0" />
        <div className="absolute inset-0 bg-gradient-to-t from-neutral-100 from-[0%] via-[50%] to-transparent to-[50%]" />


      </div>

      {/* Контент */}
      <div className="relative z-10 w-full h-full min-h-[806px] md:min-h-[810px] px-0 md:px-0">
        {/* Бірінші блок - заголовок */}
        <div className="absolute w-auto lg:w-[780px] h-44 md:h-auto top-[146px] md:top-[155px] left-10 right-10 md:left-auto md:right-[188px] bg-red-900/90 flex items-center justify-center md:py-[66px] md:px-[110px]">
          <h2 className="text-center text-[#FCFCFC] w-72 md:w-auto text-2xl md:text-4xl font-normal font-['Forum'] uppercase leading-[26px] md:leading-[44px] whitespace-pre-line">
            {t("about.bannerTitle")}
          </h2>
        </div>

        {/* Екінші блок - мәтін */}
        <div className="absolute w-auto lg:w-[650px] min-h-[350px] md:min-h-0 h-64 md:h-auto top-[334px] md:top-auto md:bottom-[110px] left-10 right-10 md:left-auto md:right-[84px] bg-red-900/90 flex items-center md:p-6 lg:p-15 p-0">
          <p className="text-neutral-50  md:w-auto text-[16px] md:text-lg lg:text-xl xl:text-2xl font-light font-['Inter'] leading-[20px] md:leading-6 px-10 md:px-0 text-justify lg:text-left">
            {t("about.text")}
          </p>
        </div>
      </div>

    </section>
  );
};

export default AboutCompanySection;

